import PropTypes from "prop-types";
import React from "react";

import CustomIconButton from "../../../../../ui library/components/buttons/CustomIconButton";
import Svg, { SvgEnum } from "../../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../../ui library/HNSColors";
import TimeField from "../../../provider-management/components/fields/TimeField";

export default function TimeWindowRow({
  canDelete,
  dayIndex,
  onChange,
  onDelete,
  time,
  timingIndex,
}) {
  const handleTimeChange = (field) => (newValue) => {
    if (newValue instanceof Date) {
      onChange(dayIndex, timingIndex, field, newValue.toTimeString().slice(0, 8));
    }
  };

  return (
    <div className="flex flex-row items-center justify-between gap-3">
      <div className="flex w-[90%] gap-6">
        <TimeField label="Start of Availability" value={time.startTime} onChangeVal={handleTimeChange("startTime")} />
        <TimeField label="End of Availability" value={time.endTime} onChangeVal={handleTimeChange("endTime")} />
      </div>
      {canDelete ? (
        <div className="mt-5 flex h-full flex-col items-center justify-center gap-1">
          <CustomIconButton
            iconVisible
            CustomIcon={
              <Svg
                name={time.id ? SvgEnum.HisTrash2 : SvgEnum.HisX}
                color={HNSColors.failure[500]}
                onClick={() => onDelete(dayIndex, timingIndex)}
                sx={{ height: 24, width: 24 }}
              />
            }
          />
        </div>
      ) : null}
    </div>
  );
}

TimeWindowRow.propTypes = {
  canDelete: PropTypes.bool.isRequired,
  dayIndex: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  time: PropTypes.object.isRequired,
  timingIndex: PropTypes.number.isRequired,
};
